import { isAnchorEqual } from '../types';
import { useCommentState } from './useCommentState/useCommentState';

export const useOpenCommentsForZone = (zone: string) => {
  const comments = useCommentState(state => state.comments);
  return comments
    .filter(comment => !comment.resolved)
    .filter(
      comment => comment.anchor && isAnchorEqual(comment.anchor, { zone }),
    );
};
